/**
 * Teacher Service
 * Handles all teacher-related API calls
 *
 * @module services/TeacherService
 */

import BaseService from "core/api/BaseService";

class TeacherService extends BaseService {
  constructor() {
    super("/teachers");
  }

  /**
   * Get all teachers
   * @param {Object} params - Query parameters
   * @returns {Promise} List of teachers
   */
  async getAll(params = {}) {
    return this.get("", params);
  }

  /**
   * Get teacher by ID
   * @param {string} id - Teacher ID
   * @returns {Promise} Teacher details
   */
  async getById(id) {
    return this.get(`${id}`);
  }

  /**
   * Get my courses (as teacher)
   * @returns {Promise} List of my courses
   */
  async getMyCourses() {
    return this.get("my-courses");
  }

  /**
   * Get my tutorials (as teacher)
   * @returns {Promise} List of my tutorials
   */
  async getMyTutorials() {
    return this.get("my-tutorials");
  }

  /**
   * Get dashboard analytics
   * @returns {Promise} Analytics data
   */
  async getDashboardAnalytics() {
    return this.get("analytics/dashboard");
  }

  /**
   * Get financial transactions
   * @param {Object} params - Query parameters (period, page, etc)
   * @returns {Promise} Financial data
   */
  async getFinancials(params = {}) {
    return this.get("analytics/financials", params);
  }

  /**
   * Get ranked "Maeștri în studio" mentors.
   * Ranking is computed server-side (online > followed > instrument match > popularity).
   * @param {Object} params - { channel, limit }
   * @returns {Promise} { mentors: [...] }
   */
  async getStudioMentors(params = {}) {
    return this.get("studio", params);
  }
}

export default new TeacherService();
